import React from "react";
import { AuthModel } from "src/model/AuthModel";
import { AuthService } from "src/model/AuthService";

export const AuthContext = React.createContext(new AuthModel(new AuthService()));
